import { CreditReportProductDetail } from "Views/Components/CreditReportSettings/CreditReportProductList";
import { MonitorCustomerDetail } from "../../GenerateCreditReport";
import { OrderItem, PaymentSummaryCard } from "Views/Components/PaymentSummaryCard/PaymentSummaryCard";
import { gstRate } from "Util/PaymentSummaryUtil";

type Props = {
	businessEntityName: string;
	creditReportProducts: CreditReportProductDetail[];
	monitorCustomer: MonitorCustomerDetail | null;
}

export const PaymentSummarySegment: React.FunctionComponent<Props> = ({
	businessEntityName,
	creditReportProducts,
	monitorCustomer,
}) => {
	// reporting total
	const originalReportingtotal = creditReportProducts.reduce((acc, product) => acc + product.originalPrice, 0);
	const reportingTotal = (creditReportProducts.reduce((acc, product) => acc + product.price, 0));

	// monitoring fee
	const includeMonitoringFee = monitorCustomer?.id &&  monitorCustomer.billingAmount > 0 && monitorCustomer?.addCustomer;
	const monitoringFee = includeMonitoringFee ? monitorCustomer.billingAmount : 0;

	// order items
	const orderItems: OrderItem[] = [{ id: "reporting", name: "Report Total", price: reportingTotal, originalPrice: originalReportingtotal }];
	if (includeMonitoringFee) {
		// add monitoring fee to order items
		// monitoring fee is a fixed fee and no discount is applied to it
		orderItems.push({ id: monitorCustomer.id, name: monitorCustomer.name, price: monitoringFee, originalPrice: monitoringFee });
	}

	return (
		<PaymentSummaryCard
			paymentSummary={{
				billedTo: businessEntityName,
				orderItems: orderItems,
				gstRate: gstRate,
			}}
		/>
	)
}